import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SortConfiguration } from '../components/generics/data-table/data-table.component';
import { ServicioContratado } from '../models/servicio-contratado.model';
import { TipoProducto } from '../models/cobertura.model';
import { UtilsService } from './utils.service';

@Injectable({
    providedIn: 'root'
})
export class ServiciosContratadosService {

    constructor(
        private http: HttpClient,
        private utilsService: UtilsService
    ) { }

    getServiciosContratados(page: number, itemsPerPage: number, sorts: SortConfiguration[], tipoProducto?: TipoProducto, ocultarInactivos = true) {
        const url = '/calculadora/servicios-contratados';
        const headers = {
            'page-number': String(page),
            'page-size': String(itemsPerPage)
        };
        const params: any = {
            'sort-by': this.utilsService.generateSortQueryParam(sorts),
            'ocultar-inactivos': String(ocultarInactivos)
        };
        if (tipoProducto) {
            params['tipo-producto'] = tipoProducto;
        }
        return this.http.get<ServicioContratado[]>(url, { headers, observe: 'response', params });
    }

    getServicioContratadoById(id: number) {
        return this.http.get<ServicioContratado>(`/calculadora/servicios-contratados/${id}`);
    }

    createServicioContratado(servicio: ServicioContratado) {
        return this.http.post<ServicioContratado>('/calculadora/servicios-contratados', servicio);
    }

    updateServicioContratado(servicio: ServicioContratado) {
        return this.http.put<ServicioContratado>(`/calculadora/servicios-contratados/${servicio.id}`, servicio);
    }

    deleteServicioContratado(id: number) {
        return this.http.delete<ServicioContratado>(`/calculadora/servicios-contratados/${id}`);
    }
}
